import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiUser, PapiPremiumFolderData } from '@wix/da-types-papi';
import { IconSize } from '@wix/da-shared-react/pkg/Icons/IconWrap';
import EyeDisc from '@wix/da-shared-react/pkg/Icons/EyeDisc';
import PremiumFolderDisc from '@wix/da-shared-react/pkg/Icons/PremiumFolderDisc';
import PointsIcon from '@wix/da-shared-react/pkg/Icons/Points';
import Button from '@wix/da-shared-react/pkg/Button';
import WatchButton from '@wix/da-shared-react/pkg/Button/ProfileOwnerWatchButton';
import BasePaywall from '../BasePaywall';
import s from './FolderPaywall.scss';

export interface Props {
  premiumFolderData?: NonNullable<PapiPremiumFolderData>;
  contentOwner: PapiUser;
  showPremiumFolderPopup: (folderId: number) => void;
  folderId?: number;
  children: React.ReactNode;
}

const FolderPaywall: React.FC<Props> = ({
  contentOwner,
  premiumFolderData,
  showPremiumFolderPopup,
  folderId,
  children,
}) => {
  const { t } = useTranslation();
  const { type, hasAccess, pointsPrice, dollarPrice } = premiumFolderData || {};
  const onShowPopup = useCallback(() => {
    if (folderId) {
      showPremiumFolderPopup(folderId);
    }
  }, [folderId, showPremiumFolderPopup]);
  return (
    <>
      {!hasAccess && type === 'paid' && (
        <BasePaywall
          icon={<PremiumFolderDisc size={IconSize.MEDIUM} />}
          text={t('paywall.premium.folder.text')}
          button={
            <Button view="b18" onClick={onShowPopup}>
              <span className={s['buttonLabel']}>
                {t('paywall.premium.folder.unlockFor')}${dollarPrice} /{' '}
                <PointsIcon size={IconSize.TINY} disableDefaultColors />
                {pointsPrice}
              </span>
            </Button>
          }
        >
          {children}
        </BasePaywall>
      )}
      {!hasAccess && type === 'watchers' && (
        <BasePaywall
          icon={<EyeDisc size={IconSize.MEDIUM} />}
          text={t('paywall.watchersOnly.folder.text')}
          button={<WatchButton view="b1" user={contentOwner!} />}
        >
          {children}
        </BasePaywall>
      )}
      {(hasAccess || !type) && children}
    </>
  );
};
FolderPaywall.displayName = 'FolderPaywall';

export default FolderPaywall;
